const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    SENTRY_URL: process.env.REACT_APP_SENTRY_URL,
    SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
};

export default config;
